import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/Fees/PayableAmount`;

export const getProducts = async () => {
  const url = `${baseRoute}/Products`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getSupplements = async () => {
  const url = `${baseRoute}/Supplements`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const putPayable = async payable => {
  const url = `${baseRoute}`;
  const headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payable),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
